import { render, staticRenderFns } from "./RestaurantSlots.vue?vue&type=template&id=48ce7802&scoped=true&"
import script from "./RestaurantSlots.vue?vue&type=script&lang=js&"
export * from "./RestaurantSlots.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantSlots.vue?vue&type=style&index=0&id=48ce7802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ce7802",
  null
  
)

export default component.exports